// Portfolio positions panel event definitions (spec 083).
//
// Two events:
//   1. PORTFOLIO_POSITIONS_TOGGLED — emitted when the user flips the
//      Open/Closed segmented control on `<PortfolioPositionsCard>`.
//   2. PORTFOLIO_POSITION_SELL_CLICKED — emitted when the user clicks the
//      per-row Sell button. Closes the SC-007 measurement loop together
//      with the `entry_point: 'portfolio_sell_deeplink'` field on the
//      downstream `trade_success` event.

import type { EventDefinition } from './navigation';

export type PortfolioPositionsToggledProperties = {
  to: 'open' | 'closed';
};

export type PortfolioPositionSellClickedProperties = {
  marketPubkey: string;
  outcomeIndex: number;
};

export const PORTFOLIO_POSITIONS_TOGGLED: EventDefinition<PortfolioPositionsToggledProperties> = {
  name: 'portfolio_positions_toggled',
};

export const PORTFOLIO_POSITION_SELL_CLICKED: EventDefinition<PortfolioPositionSellClickedProperties> =
  {
    name: 'portfolio_position_sell_clicked',
  };
